const historicalReducer = data => {
  let results = [];
  data.forEach(element => {
    results.push(element.name);
  });
  return results;
};

export default historicalReducer;
